/** Phone shell copy. English only. */
export const mobile = {
  tabs: { label: "Main", home: "Home", inbox: "Inbox", members: "Members", leads: "Leads", more: "More", fab: "Quick actions" },
  top: { search: "Search", bell: "Notifications", switchBranch: (current: string) => `Switch gym or branch, current ${current}`, back: "Back" },
  fab: {
    title: "Quick actions", sub: "What do you want to do?",
    newMember: "New member", collect: "Collect payment", checkin: "Check in member", trial: "Book trial", task: "Add task", expense: "Add expense",
  },
  branch: { title: "Gym and branch", sub: "Pick where you are working", all: "All branches", switchBusiness: "Switch gym" },
  bell: { title: "Notifications" },
  search: {
    placeholder: "Search members, leads, pages", placeholderMembers: "Find a member to check in", cancel: "Cancel", label: "Search",
    recent: "Recent", jump: "Jump to", people: "People", pages: "Pages", none: (q: string) => `No results for “${q}”`, minChars: "Type at least 2 letters to search people.", clearRecent: "Clear",
    members: "Members", leads: "Leads", searching: "Searching",
  },
  more: {
    title: "More", eyebrow: "Everything else", signOut: "Sign out", signOutEverywhere: "Sign out everywhere", profile: "Profile",
    soon: "Coming soon",
  },
} as const;
